// DTMF keypad for phone menus and extensions. Digits typed while it is open go to the call (see dialer/hotkeys.ts).
import { useState } from 'preact/hooks';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

/** `sent` (optional) shows digits sent from elsewhere too, e.g. typed on the keyboard while the keypad is open. */
export function Keypad(props: { onDigit: (d: string) => void; extension?: string | null; onClose: () => void; sent?: string }) {
  const [localSent, setLocalSent] = useState('');
  const sent = props.sent ?? localSent;
  const press = (d: string) => { props.onDigit(d); if (props.sent === undefined) setLocalSent((s) => (s + d).slice(-24)); };
  return (
    <div class="vd-keypad" role="group" aria-label="Keypad">
      <div class="vd-keypad-sent mono" aria-live="polite">{sent || 'Type or click digits'}</div>
      <div class="vd-keypad-grid">
        {KEYS.map((k) => <button class="btn" onClick={(e) => { press(k); (e.currentTarget as HTMLElement).blur(); }}>{k}</button>)}
      </div>
      <div class="row" style="justify-content:space-between;margin-top:8px">
        {props.extension
          ? <button class="btn btn-sm" onClick={() => { const ext = props.extension!.replace(/[^0-9*#]/g, ''); if (ext) press(ext); }}>Send ext. {props.extension}</button>
          : <span />}
        <button class="btn btn-sm" onClick={props.onClose}>Close <kbd>Esc</kbd></button>
      </div>
    </div>
  );
}
